import { render, staticRenderFns } from "./CodeToken.vue?vue&type=template&id=1808da6d&"
import script from "./CodeToken.vue?vue&type=script&lang=js&"
export * from "./CodeToken.vue?vue&type=script&lang=js&"
import style0 from "./CodeToken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports